import {FC, useEffect} from 'react'

import useLoadData from '@/hooks/useLoadData.ts';
import {useAppContext} from '@/context/app';


const InitialDataLoader: FC = () => {


    const {loaded, auth} = useAppContext()
    const {loadData} = useLoadData()

    useEffect(() => {
        loadData().catch(err => console.error('LoadingDataError: ', err))
    }, [loaded, auth])

    return null
}

export default InitialDataLoader
